/* eslint-disable */
let initialRun = true

function acs_showLoading () {
  const loading = document.querySelector('.acs_loading')
  if (loading) loading.style.display = 'block'
}

function acs_hideLoading () {
  const loading = document.querySelector('.acs_loading')
  if (loading) loading.style.display = 'none'
}

function acs_fetchPlp () {
  graphenehc.load({
    template: { id: 'category', target: '.acs_results' },
    /*include         : ["breadcrumb", "page"],*/
    init: function () {
      ACScript.skeletonLoading(8)
    },
    success: function (response) {
      ACScript.removeSkeletonLoading()

      // Filters
      const filtersEl = document.querySelector('.clc-Filters')
      if (filtersEl) {
        filtersEl.innerHTML = response?.templates?.search?.sub_templates?.facets_html
        ACScript.filterDrawer()
      }

      let acsHeader = document.querySelector('.acs_header div')
      let acsClcHeader = document.querySelector('.acs_clc_header .clc-Detail_Filter')
      insertAfter(acsClcHeader, acsHeader)
    }
  })
}

function insertAfter (referenceNode, newNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
}

function acs_fetchSearch () {
  graphenehc.load({
    template: { id: 'search', target: '.acs_results' },
    include: ['page'],
    init: function () {
      ACScript.skeletonLoading(8)
    },
    success: function (response) {
      ACScript.removeSkeletonLoading()

      // Filters
      const filtersEl = document.querySelector('.clc-Filters')
      if (filtersEl) {
        filtersEl.innerHTML = response?.templates?.search?.sub_templates?.facets_html
        ACScript.filterDrawer()
      }

      // Update title
      const searchTerm = response.header.search_text
      const productCount = response.templates.search.product_count
      const title = document.querySelector('[data-search-title]')
      const titleLocaleTemplate = title && title.getAttribute('data-search-title-locale-template')
      if (searchTerm && productCount >= 0 && title && titleLocaleTemplate) {
        title.innerText = titleLocaleTemplate
          .replace('[product_count]', productCount)
          .replace('[search_term]', searchTerm)
      }

      // Update no results text
      const noResultsText = document.querySelector('[data-no-results-text]')
      if (noResultsText) {
        if (productCount <= 0) {
          noResultsText.classList.remove('sch-Hide')
        } else {
          noResultsText.classList.add('sch-Hide')
        }
      }

      // Check for section to be injected into GrapheneHC content
      window.setTimeout(() => {
        const sectionsToMove = document.querySelectorAll('[data-search-section]')
        sectionsToMove.forEach(section => {
          const sectionContent = section.innerHTML
          const sectionName = section.getAttribute('data-search-section')
          const sectionDestination = document.querySelector(
            `[data-search-section-destination="${sectionName}"]`
          )

          if (!sectionContent || !sectionName || !sectionDestination) return

          // Update content
          sectionDestination.innerHTML = sectionContent

          // Reveal content
          sectionDestination.classList.remove('sch-Hide')
          sectionDestination.style.display = 'block'

          // Remove container styles if found
          console.log(sectionDestination.querySelector('.lyt-Container'))
          sectionDestination.querySelector('.lyt-Container')?.classList.remove('lyt-Container')
        })
      }, 250)
    }
  })
}

function acl_getNextPage () {
  let nextPage = 2
  document.querySelectorAll('#acs_ProductListCount').forEach(function (div) {
    const pg = div.dataset.page
    if (pg) nextPage = parseInt(pg) + 1
  })
  graphenehc.load_page({
    page_number: nextPage,
    set_page_url: true,
    // args: { device: deviceView },
    init: function () {
      // custom code here - e.g. insert content loading icon
      document.getElementById('acs_loadMore').style = 'display:none'
      ACScript.skeletonLoading(8)
    },
    success: function (response) {
      ACScript.removeSkeletonLoading()
      // add new page
      let template = response.templates.category || response.templates.search
      let container = document.getElementById('acs_ProductList')
      let loadBtn = document.getElementById('acs_loadMore')
      container.innerHTML += template.html

      // update progress
      let progress = Math.min(template.current_page * template.page_size, template.count)
      if (progress == template.count) {
        loadBtn.setAttribute('disabled', 'disabled')
        loadBtn.style = 'display:none'
      } else {
        loadBtn.style = 'display:block'
      }
    }
  })
}

document.addEventListener('DOMContentLoaded', function (e) {
  //alert(`Document is ready!`);
  const searchEnabled = document.querySelector('#graphene-status').dataset.searchEnabled
  if (searchEnabled === 'true') {
    document.querySelector('form.src-Form').action = '/pages/search'
  }
})

ACScript = {
  filterDrawer: function () {
    const drawers = document.querySelector('.drw-Drawers')

    const drawer = document.getElementById('acs_filterDrawer')
    const drawerBtn = document.getElementById('acs_filterBtn')
    const filterOptions = document.querySelectorAll('.clc-FilterBlock_Choice')
    const filterClose = document.querySelectorAll('.acs_closeFilters')

    drawerBtn?.addEventListener('click', function () {
      drawers.classList.toggle('drw-Drawers-active')
      drawer.classList.toggle('drw-Drawer-active')
    })

    for (let i = 0; i < filterClose.length; i++) {
      filterClose[i].addEventListener('click', function () {
        drawers.classList.remove('drw-Drawers-active')
        drawer.classList.remove('drw-Drawer-active')
      })
    }

    document.addEventListener('mouseup', function (e) {
      // if the target of the click isn't the container nor a descendant of the container
      if (!drawer.contains(e.target)) {
        drawers.classList.remove('drw-Drawers-active')
        drawer.classList.remove('drw-Drawer-active')
      }
    })

    for (let i = 0; i < filterOptions.length; i++) {
      filterOptions[i].addEventListener('click', function () {
        if (this.getAttribute('aria-current') == 'true') {
          this.setAttribute('aria-current', 'false')
        } else {
          this.setAttribute('aria-current', 'true')
        }
      })
    }

    const scroll = document.querySelector('.acs_filter_scroll')
    let scrolling = false
    scroll.addEventListener('scroll', function (e) {
      scrolling = true
    })
    setInterval(() => {
      if (scrolling) {
        scrolling = false
        // place the scroll handling logic here
        document.querySelector('.cover-bar').style.opacity = 0
      } else {
        document.querySelector('.cover-bar').style.opacity = 1
      }
    }, 300)
  },
  skeletonLoading: function (t) {
    const container = document.querySelector('.acs_ProducList_skeleton')
    const cardTemplate = document.getElementById('acs_skeleton_template')
    for (let i = 0; i < t; i++) {
      container.append(cardTemplate.content.cloneNode(true))
    }
  },
  removeSkeletonLoading: function () {
    document.querySelectorAll('.acs_skeleton_toolbar').forEach(function (item) {
      item.classList.add('hidden')
    })
    const container = document.querySelector('.acs_ProducList_skeleton')
    while (container.firstChild) {
      container.removeChild(container.firstChild)
    }
  },
  productTracking: function () {
    $g.track({
      scope: 'view',
      action: 'add',
      data: { product_id: meta.product.id }
    })
    document.querySelector('.prd-ProductOffers_Submit').addEventListener('click', function () {
      $g.track({
        scope: 'basket',
        action: 'add',
        data: { product_id: meta.product.id, quantity: 1 }
      })
    })
  }
}
